import { Scale, ResponseGetScale } from './../../../../core/models/scale.model';
import { ScaleBulkPost, ResponseOk } from '../../../../core/models/scale.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { ScalePost } from 'src/app/core/models/scale.model';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';

@Injectable({
  providedIn: 'root'
})
export class ScaleService {

  constructor(
    private http: HttpClient,
    private environmentService: EnvironmentService
  ) { }

  public uri = this.environmentService.getEnvVar('api_leads');

  saveScales(data: ScaleBulkPost): Observable<ResponseOk> {
    return this.http.post<ResponseOk>(`${this.uri}/bulk-update/scales`, data);
  }

  saveScale(data: ScalePost): Observable<ResponseOk> {
    return this.http.post<ResponseOk>(`${this.uri}/update/scale`, data);
  }

  getScale(userId: string): Observable<ResponseGetScale> {
    return this.http.get<ResponseGetScale>(`${this.uri}/agent/scale?agent=${userId}`);
  }
}
